/**
 * 趣味加载文案 — AI 解读等待时轮播（PC端）
 */

const messages = {
  default: [
    '命运的齿轮正在转动...',
    '宇宙正在为你排列组合...',
    '请稍候，灵感正在传输中...',
    '正在连接平行宇宙的你...',
    '神秘力量加载中...',
    '一切皆有定数，包括等待时间...',
    '你的耐心正在被命运记录',
    '好事多磨，好卦多等',
  ],
  tarot: [
    '牌灵正在洗牌，它说手气不错',
    '你的牌在争论谁先出场',
    '塔罗师正在阅读你的 aura',
    '78 张牌正在投决定性一票',
    '牌面说：别催，好戏正在上演',
    '你抽到的牌正在互相交换意见',
    '不属于这个时代的愚者，正在灰雾之上俯瞰',
    '神秘的黄黑之王执掌好运，正在为你翻牌',
    '塔罗牌表示很忙，请稍后再试',
    '命运的使者正在解读牌面密码',
    '牌灵说你今天的运气有点复杂',
    '塔罗牌正在排队等候你的召唤',
  ],
  iching: [
    'DeepSeek泄露的天机，关我什么事',
    '卦象正在穿越三千年找你',
    '周公说他午休了，让AI代班',
    '六爻正在排兵布阵',
    '天地人三才正在开会讨论你的事',
    '你的卦象太特殊，天机正在审批中',
    '太极生两仪，两仪生... 等等我还没算完',
    '文王表示：这个卦很有意思',
    '你的问题把卦象整不会了',
    '三千年前的智慧正在适配5G网络',
  ],
  dream: [
    '弗洛伊德和周公正在吵架',
    '你的梦太离谱，AI需要缓一下',
    '正在解析你的潜意识暗号',
    '周公说这个梦他也没见过',
    '你的梦境正在被逐帧分析',
    '梦里的你比现实更忙',
    'AI正在进入你的梦境...',
    '潜意识表示：这个信息量有点大',
    '你的梦已被列入重点研究对象',
    '解梦师正在和你的梦谈判',
  ],
  bazi: [
    '天干地支正在排兵布阵',
    '你的命盘太复杂，AI需要深呼吸',
    '五行正在开会讨论你的命理',
    '十神表示你的人生剧本很精彩',
    '大运小运正在排期中',
    '你的八字让AI陷入了沉思',
    '日主说：让我想想怎么解释',
    '命理师正在和你的命运博弈',
    '四柱正在互相推让C位',
    '你的八字信息量太大，AI请求增援',
  ],
  persona: [
    '正在读取你的灵魂编码',
    '你的数字分身正在觉醒',
    'AI正在思考你是谁，挺难的',
    '你的灵魂数据正在同步到云端',
    '人格碎片正在拼装中...',
    'AI表示：这个用户有点复杂',
    '你的灵魂正在被深度扫描',
    '画像师正在描绘你的精神轮廓',
    '你的数据画像比蒙娜丽莎还难画',
    '分身正在学习如何成为你',
  ],
}

/** 获取随机文案列表（用于轮播） */
export function getLoadingMessages(category, count = 10) {
  const pool = messages[category] || messages.default
  const shuffled = [...pool].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, Math.min(count, pool.length))
}

/** 获取单条随机文案 */
export function getRandomMessage(category) {
  const pool = messages[category] || messages.default
  return pool[Math.floor(Math.random() * pool.length)]
}
